const getSortedArrayFromSet = (set, locale = undefined)=>{
    return Array.from(set).sort((a, b)=>a.localeCompare(b, locale, {
            numeric: true
        })
    ).map((item)=>({
            label: item.toString(),
            value: item
        })
    );
};
const getFilterOptions = (options = [])=>{
    const arr = options instanceof Set ? getSortedArrayFromSet(options) : options;
    return arr.reduce((prev, curr)=>{
        prev[curr.label] = curr.value;
        return prev;
    }, {});
};
const formatPowerValues = (values)=>{
    return getSortedArrayFromSet(values).map(({ value  })=>({
            label: value,
            value
        })
    ).sort((a, b)=>powerToFloat(a) - powerToFloat(b)
    );
};
function powerToFloat(power) {
    return powerValueToFloat(power === null || power === void 0 ? void 0 : power.value);
}
function powerValueToFloat(powerValue) {
    return parseFloat(powerValue.replace(/[^\d.+-]/g, ''));
}
const sortPowerOptions = (a, b)=>{
    return powerValueToFloat(a) - powerValueToFloat(b);
};

export { formatPowerValues, getFilterOptions, getSortedArrayFromSet, powerToFloat, powerValueToFloat, sortPowerOptions };
//# sourceMappingURL=ContactLensesUtils.js.map
